import { ProductCarousel } from "@/components/marketplace"
import type { ProductCarouselSection } from "@/features/feed/contract"
import { mapFeedProduct } from "@/features/feed/map-product"
import { resolveSeeAllLink } from "@/features/feed/resolve-link"
import { feedHeaderSize, SectionFrame } from "@/features/feed/sections/SectionFrame"
import type { FeedSectionProps } from "@/features/feed/sections/types"

export const ProductCarouselFeedSection = ({ section, context }: FeedSectionProps<ProductCarouselSection>) => {
  const { title } = section.presentation
  if (!title || section.data.products.length === 0) return null
  const seeAllHref = resolveSeeAllLink(title.seeAll, section.type, context.countryCode, context.page)
  return (
    <SectionFrame section={section} context={context} ownsHeader>
      <ProductCarousel
        title={title.text}
        accent={title.accent}
        eyebrow={title.eyebrow}
        headerSize={feedHeaderSize(title.style)}
        numeral={title.numeral}
        seeAllHref={seeAllHref}
        variant={section.presentation.variant === "compact" ? "compact" : "default"}
        products={section.data.products.map((product) => mapFeedProduct(product, context.countryCode))}
      />
    </SectionFrame>
  )
}
